import React, { useState } from "react";
import { ProcessWrapper, ProgressBar, ProgressBarIndicator } from "../styled";
import Contact from "../../components/contact/contact";
import Question from "../../components/question";
import { ReactComponent as Car } from "../../assets/img/svg/confiansa_carro 2.svg";
import { ReactComponent as WaitTime } from "../../assets/img/svg/confiansa_espera.svg";
import { ReactComponent as Bike } from "../../assets/img/svg/confiansa_Bici.svg";

export default function Vehicle({
  finishProcess,
  setRecommendation,
  startOver,
  setContact,
  setAssuranceUrl,
  contact,
  secondaryStep,
  specificStep,
}) {
  const [step, setStep] = useState(
    secondaryStep !== undefined ? secondaryStep : 0
  );

  const nextStep = () => {
    setStep(step + 1);
  };

  const goToStep = (newStep) => {
    setStep(newStep);
  };

  return (
    <ProcessWrapper>
      <ProgressBar>
        <ProgressBarIndicator progressWidth={(100 * (step + 1)) / 4} />
      </ProgressBar>

      {step === 0 && (
        <Contact
          nextStep={nextStep}
          setContact={setContact}
          contact={contact}
        />
      )}
      {step === 1 && (
        <Question
          goToStep={() =>
            secondaryStep !== 0 ? specificStep("heritage", 1) : goToStep(0)
          }
          text="¿Qué tipo de vehículo quieres proteger?"
          icon={<Car fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          options={[
            {
              label: "Automóvil",
              action: () => setStep(2),
            },
            {
              label: "Motocicleta",
              action: () => setStep(3),
            },
          ]}
        />
      )}
      {step === 2 && (
        <Question
          goToStep={() => goToStep(1)}
          text="¿Cuál es la antigüedad de tu vehículo?"
          icon={<WaitTime fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          options={[
            {
              label: "Entre 0 y 15 años de antigüedad",
              action: () => {
                setRecommendation({
                  title: "Seguro completo",
                  phrase1: "¡Te recomendamos contratar un seguro completo!",
                  phrase2: "",
                });
                setAssuranceUrl(
                  "https://confiansa.bi.com.gt/seguro-completo-para-automovil/"
                );
                finishProcess();
              },
            },
            {
              label: "Mayor a 15 años de antigüedad",
              action: () => {
                setRecommendation({
                  title: "Seguro de daños a terceros",
                  phrase1:
                    "¡Te recomendamos contratar un seguro de daños a terceros!",
                  phrase2: "",
                });
                setAssuranceUrl(
                  "https://confiansa.bi.com.gt/responsabilidad-civil-automovil/"
                );
                finishProcess();
              },
            },
          ]}
        />
      )}
      {step === 3 && (
        <Question
          goToStep={() => goToStep(1)}
          text="¿Qué uso le das a tu motocicleta?"
          icon={<Bike fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          options={[
            {
              label: "Particular",
              action: () => setStep(4),
            },
            {
              label: "Para entregas",
              action: () => {
                setRecommendation({
                  title: "Delivery Robo y RC",
                  phrase1:
                    "¡Te recomendamos el seguro para Delivery Robo y RC!",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/contacto/");
                finishProcess();
              },
            },
          ]}
        />
      )}
      {step === 4 && (
        <Question
          goToStep={() => goToStep(3)}
          text="¿Cuál es la antigüedad de tu motocicleta?"
          icon={<WaitTime fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          options={[
            {
              label: "Entre 0 y 5 años de antigüedad",
              action: () => {
                setRecommendation({
                  title: "Seguro Completo",
                  phrase1:
                    "¡Te recomendamos un seguro completo para tu motocicleta!",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/contacto/");
                finishProcess();
              },
            },
            {
              label: "Entre 5 y 7 años de antigüedad",
              action: () => {
                setRecommendation({
                  title: "Contra robo y daños a terceros",
                  phrase1:
                    "¡Te recomendamos contratar un seguro contra robo y daños a terceros!",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/seguro-de-moto/");
                finishProcess();
              },
            },
          ]}
        />
      )}
    </ProcessWrapper>
  );
}
